import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LIKELINESS_OPTIONS, LikelinessIcon } from "./constants";

const LikelinessSelect = ({ value, onValueChange, disabled = false }) => {
  return (
    <Select value={value || "YES"} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className="h-9">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="YES">
          <div className="flex items-center gap-1">
            <LikelinessIcon type="YES" />
            <span className="text-xs">YES</span>
          </div>
        </SelectItem>
        <SelectItem value="MIGHT">
          <div className="flex items-center gap-1">
            <LikelinessIcon type="MIGHT" />
            <span className="text-xs">MIGHT</span>
          </div>
        </SelectItem>
        <SelectItem value="NOT">
          <div className="flex items-center gap-1">
            <LikelinessIcon type="NOT" />
            <span className="text-xs">NOT</span>
          </div>
        </SelectItem>
        <SelectItem value="CANCELLED">
          <div className="flex items-center gap-1">
            <LikelinessIcon type="CANCELLED" />
            <span className="text-xs">CANCELLED</span>
          </div>
        </SelectItem>
        <SelectItem value="FREE">
          <div className="flex items-center gap-1">
            <LikelinessIcon type="FREE" />
            <span className="text-xs">FREE</span>
          </div>
        </SelectItem>
      </SelectContent>
    </Select>
  );
};

export default LikelinessSelect;
